import React from 'react';
import PropTypes from 'prop-types';
import Parser from 'html-react-parser';

import './style.scss';

const Body = props => {
    const classes = props.classes || 'body-text';
    const files = props.files;
    const options = {
        replace: node => {
            if (node.type === 'tag' && node.name === 'img') {
                console.warn(
                    'Encountered an <img> tag in text body, consider using a media entity instead'
                );

                const uuid = node.attribs['data-entity-uuid'];
                const alt = node.attribs['alt'];
                const classes = node.attribs['class'];

                // find a file that matches our uuid
                const file = files.find(
                    ({ node }) => node.file && node.uuid === uuid
                );

                if (file) {
                    return (
                        <img
                            src={file.node.file.cis.original.src}
                            alt={alt}
                            className={classes}
                        />
                    );
                }
            } else if (node.type === 'tag' && node.name === 'drupal-entity') {
                const uuid = node.attribs['data-entity-uuid'];
                const alt = node.attribs['alt'];
                const classes = node.attribs['class'];

                // find a file node that is linked to the referenced image entity
                const file = files.find(
                    ({ node: { r, file } }) =>
                        file &&
                        r &&
                        r.image &&
                        r.image.find(img => img.uuid === uuid)
                );

                if (file) {
                    return (
                        <img
                            src={file.node.file.cis.original.src}
                            alt={alt}
                            className={classes}
                        />
                    );
                }
            }
        },
    };
    return (
        <div className={classes}>
            {props.text
                ? Parser(props.text, options)
                : Parser(props.children, options)}
        </div>
    );
};

Body.defaultProps = {
    files: [],
};

Body.propTypes = {
    /** Text passed by children */
    children: PropTypes.node,
    /** Text that is passed by a parameter */
    text: PropTypes.string,
    /** Classname passed by components */
    classes: PropTypes.string,
    /** Collection of files available */
    files: PropTypes.array.isRequired,
};

export default Body;
